import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  useMediaQuery,
  useTheme,
  Box,
  Typography,
  IconButton,
  TableHead,
  Modal,
  TextField,
  InputAdornment,
  Card,
} from "@mui/material";
import {useParams } from "react-router-dom";
import Adminimg from "../../common/assests/adminimg.png";
import CrossIcon from "../../common/assests/croosicon.png";
import SearchItem from "../../common/assests/search.svg";
import SearchIcon from "@mui/icons-material/Search";
import Paginations from "../../common/pagination/Paginations";
import { allOrderListApi, OrderDetailsApi } from "../../api";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import Loader from "../../common/loader/Loader";
import UserImg from "../../common/assests/sampleuser.svg";
import UserAllOrderRow from "../../common/tablerow/UserAllOrderRow";
import TableComp from "../../common/tablecomp/TableComp";
import UserOrderProductRow from "../../common/tablerow/UserOrderProductRow";
import configuration from "../../config/Config";


// import './Orders.css';

const AllOrder = () => {


  const token = useSelector((state) => state?.user?.user?.token);
  const { id } = useParams();
  const isSmallScreen = useMediaQuery("(max-width:480px)");
  const [allOrderData, setAllOrderData] = useState([]);
  const [orderProducts, setOrderProducts] = useState([]);

  const [totalPages, setTotalPages] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [myTimout, setMyTimeOut] = useState();

  const [open, setOpen] = useState(false);
  // const [selectedRow, setSelectedRow] = useState();

  const handleAllOrderList = async () => {
    try {
      setLoading(true);
      const response = await allOrderListApi({
        token,
        currentPage,
        id: id,
        searchQuery,
      });
      setAllOrderData(response?.orders || []);
      setCurrentPage(response?.currentPage);
      setTotalPages(response?.totalPages);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error", error);
    }
  };

  useEffect(() => {
    handleAllOrderList();
  }, [currentPage]);

  useEffect(() => {
    if (searchQuery.trim() === "") {
  
      handleAllOrderList();
    } else {

      clearTimeout(myTimout);
      const timeout = setTimeout(() => handleAllOrderList(), 500);
      setMyTimeOut(timeout);

    }
  }, [searchQuery]);
  // useEffect(() => {
  //   if(searchQuery.trim()!=""){
  //   clearTimeout(myTimout);
  //   setMyTimeOut(setTimeout(handleAllOrderList, 500));
  // }
  // }, [searchQuery]);


  const handleOrderDetail = async (id) => {
    try {
      setLoading(true);
      const response = await OrderDetailsApi({ token, id });
      // console.log("orderdetails.", response);
      setOrderProducts(response || []);
      // setCurrentPage(response?.page)
      // setTotalPages(response?.totalPages)
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error", error);
    }
  };



  const handleClickOpen = (row) => {
    handleOrderDetail(row?._id);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    // setSelectedRow(null);
  };

  const handlePageChange = (page) => {
    setLoading(true);
    setCurrentPage(page);
  };


  const titles = [
    { title: "Seller Name" },
    { title: "Address" },
    { title: "Total Price" },
    { title: "Quantity" },
    { title: "Payment Status" },
    { title: "Order Status" },
    { title: "Action" },
  ];

  const titles1 = [
    { title: "Image" },
    { title: "Product Name" },
    { title: "Category" },
    { title: "Quantity" },
    { title: "Regular Price" },
    { title: "Item Total" },
    { title: "Discounted Price" },
  ];

  return (
    <div>
      {loading ? (
        <Loader variant="table" />
      ) : (
     
        <Card
            backgroundColor={"#fff"}
            borderRadius={"35px"}
            sx={{ padding: "20px", borderRadius: "25px",marginTop: "40px", marginBottom: "30px"  }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  flexWrap: "wrap",
                  gap: "10px",
                  marginBottom: "20px",
                }}
              >
                <Typography
                  sx={{
                    fontSize: { xs: "16px", sm: "20px" },
                    fontWeight: "600",
                    color: "#362B24",
                  }}
                >
                  Order List
                </Typography>
                <TextField
                  placeholder="Search by order status"
                  value={searchQuery}
                  onChange={(e) => {
                    if (e.target.value.trim() !== "" || e.target.value === "") {
                      setSearchQuery(e.target.value);
                    }
                  }}
                  sx={{
                    width: { xs: 235, sm: 240 },
                    height: { xs: 48},
                    flexShrink: 0,
                    borderRadius: "33px",
                    background: "#EBEBEB",

                    border: "none",
                    "& .MuiOutlinedInput-input": {
                      height: "30%",
                    },
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "33px",
                      height: "100%",
                      paddingRight: "10px",
                      outline: "none",
                      border: "none",
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "none",
                    },
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <img
                          src={SearchItem}
                          sx={{ color: "#000", opacity: "0.35" }}
                        />
                      </InputAdornment>
                    ),
                    style: { height: "100%" },
                  }}
                />
              </Box>


              <TableComp title={titles}>
                {allOrderData?.length > 0 ? (
                  allOrderData?.map((item) => (               
                    <UserAllOrderRow 
                      key={item?._id}
                      order={item}
                      handleViewMore={() => handleClickOpen(item)}
                    />
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={titles.length} align="center">
                      No Data Found
                    </TableCell>
                  </TableRow>
                )}
              </TableComp>

              <Paginations
              totalPages={totalPages}
              currentPage={currentPage}
              onPageChange={handlePageChange}
              disabled={loading}
              />
              </Card>
                )}
   
          <Modal open={open} onClose={handleClose}>
            <Box
              sx={{
                maxHeight: "80vh",
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                // maxWidth: '630px',
                maxWidth: "750px",
                // maxWidth: "874px",
                width: "90%",
                bgcolor: "#F5F5F5",
                borderRadius: "32px",
                boxShadow: 24,

                overflowY: "auto",
                p: 4,
                "&::-webkit-scrollbar": {
                  display: "none",
                },
                "@media (min-width: 1600px)": {
                  width: "90vw",
                },
                "@media (max-width: 1400px)": {
                  width: "80vw",
                },
                "@media (max-width: 1200px)": {
                  width: "60vw",
                },
                "@media (max-width: 1024px)": {
                  width: "60vw",
                },
                "@media (max-width: 767px)": {
                  width: "80vw",
                },
                "@media (max-width: 576px)": {
                  width: "90vw",
                },
                "@media (max-width: 480px)": {
                  width: "95vw",
                },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "baseline",
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    marginBottom: "16px",
                    color: "#362B24",
                    fontSize: "20px",
                    fontWeight: "700",
                  }}
                >
                  Order Details
                </Typography>

                <IconButton>
                  <img
                    src={CrossIcon}
                    alt="img"
                    onClick={handleClose}
                    style={{ width: "20px", height: "20px", cursor: "pointer" }}
                  />
                </IconButton>
              </Box>
          {orderProducts ? (
              <Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "16px",
                  }}
                >
                  <Box>
                    <Typography
                      sx={{
                        fontSize: "15px",
                        fontWeight: "500",
                        color: "#362B24",
                      }}
                    >
                      Order By
                    </Typography>
                    <Typography sx={{ marginTop: "15px" }}>

                      {/* other acces needed here */}
                     <img
                            src={
                              orderProducts?.user?.picture ? `${configuration.cdnFront}/${orderProducts?.user?.picture}`
                              : UserImg
                              // orderProducts?.photos && orderProducts.photos.length > 0
                                // ? `${configuration.cdnFront}/${orderProducts.photos[0].url}`
                            }
                        alt="user-img"
                        style={{
                          height: isSmallScreen ? "35px" : "42px",
                          width: isSmallScreen ? "35px" : "45px",
                        }}
                      />
             

                      <strong> {orderProducts?.user?.fullname||"-"}</strong>
                    </Typography>
                  </Box>
                </Box>
                <br />
                <Box
                  sx={{
                    display: "grid",
                    //   gridTemplateColumns: "repeat(auto-fit, minmax(120px, 1fr))",
                    gridTemplateColumns: "repeat(auto-fit, minmax(142px, 1fr))",
                    gap: 3,
                  }}
                >
                  <Box>
                    <Typography
                      sx={{
                        fontWeight: "400",
                        opacity: "0.6",
                        color: "#362B24",
                      }}
                    >
                      Order Date
                    </Typography>
                    <Typography sx={{ fontWeight: "500", fontSize: "16px" }}>
                      <strong>
                    {orderProducts?.createdAt 
                      ? new Date(orderProducts?.createdAt).toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' }) 
                      : "-"
                    }
                  </strong>
                    </Typography>
                  </Box>
                  <Box>
                    <Typography
                      sx={{
                        fontWeight: "400",
                        opacity: "0.6",
                        color: "#362B24",
                      }}
                    >
                      Order ID
                    </Typography>
                    <Typography sx={{ fontWeight: "500", fontSize: "16px" }}>
                      <strong>{orderProducts?.orderId||"-"}</strong>
                    </Typography>
                  </Box>
                  <Box>
                    <Typography
                      sx={{
                        fontWeight: "400",
                        opacity: "0.6",
                        color: "#362B24",
                      }}
                    >
                      Order Status
                    </Typography>
                    <Typography sx={{ fontWeight: "500", fontSize: "16px" }}>
                      <strong>{orderProducts?.status||"-"}</strong>
                    </Typography>
                  </Box>

                  <Box>
                    <Typography
                      sx={{
                        fontWeight: "400",
                        opacity: "0.6",
                        color: "#362B24",
                        fontSize: "15px",
                      }}
                    >
                      Payment Status
                    </Typography>
                    <Typography sx={{ fontWeight: "500", fontSize: "16px" }}>
                      <strong>{orderProducts?.paymentStatus||"-"}</strong>
                    </Typography>
                  </Box>
                  <Box>
                    <Typography
                      sx={{
                        fontWeight: "400",
                        opacity: "0.6",
                        color: "#362B24",
                      }}
                    >
                      Card
                    </Typography>
                    <Typography sx={{ fontWeight: "500", fontSize: "16px" }}>
                      <strong>{orderProducts?.card||"-"}</strong>
                    </Typography>
                  </Box>

                  <Box>
                    <Typography
                      sx={{
                        fontWeight: "400",
                        opacity: "0.6",
                        color: "#362B24",
                      }}
                    >
                      Total Price
                    </Typography>
                    <Typography sx={{ fontWeight: "500", fontSize: "16px" }}>
                      <strong>{`$${orderProducts?.totalAmount || "-"}`}</strong>
                    </Typography>
                  </Box>

                  <Box>
                    <Typography
                      sx={{
                        fontWeight: "400",
                        opacity: "0.6",
                        color: "#362B24",
                      }}
                    >
                      Shipping Address
                    </Typography>
                    <Typography sx={{ fontWeight: "500", fontSize: "16px" }}>
                      <strong>{orderProducts?.address 
                        ? [
                            orderProducts?.address.address || "", 
                            orderProducts?.address.city || "",
                            orderProducts?.address.state || "",
                            orderProducts?.address.country || "",
                            orderProducts?.address.zipcode || ""
                          ]
                            .filter(Boolean)  
                            .join(", ")      
                        : "-"                
                      }</strong>
                    </Typography>
                  </Box>
                  <Box>
                    <Typography
                      sx={{
                        fontWeight: "400",
                        opacity: "0.6",
                        color: "#362B24",
                      }}
                    >
                      Seller Name
                    </Typography>
                    <Typography variant="body2" sx={{ marginTop: "8px" }}>
                    <img
                            src={
                              orderProducts?.seller?.picture ? `${configuration.cdnFront}/${orderProducts?.seller?.picture}`
                              : UserImg
                            }
                        alt="User"
                        style={{
                          width: "42px",
                          height: "42px",
                          marginRight: "5px",
                        }}
                      />
                      <strong> {orderProducts?.seller?.fullname||"-"}</strong>
                    </Typography>
                  </Box>
                </Box>

                <Card
                  backgroundColor={"#fff"}
                  borderRadius={"35px"}
                  sx={{ padding: "20px", borderRadius: "25px",marginTop: "40px",  }}
                  >
           
              <TableComp title={titles1}>
                     {orderProducts?.items?.length >0 ?(
                        orderProducts?.items?.map((rows) => (            
                    <UserOrderProductRow 
                      key={rows?._id}
                      row={rows}
                    />
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={titles.length} align="center">
                      No Data Found
                    </TableCell>
                  </TableRow>
                )}
              </TableComp>
              </Card>
              
              </Box>
          ) : (
            <Typography>Order Not Found</Typography>
          )}
            </Box>
          </Modal>
       
   
    </div>
  );
};

export default AllOrder;
